import React, { useEffect, useRef, createElement } from 'react';
const PIXEL_ID = '2832673310418578';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  const initialized = useRef(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (initialized.current) return;
    initialized.current = true;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
      s && s.parentNode && s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    // Debug log — confirma en consola que el pixel se inicializó
    // eslint-disable-next-line no-console
    console.log('[Meta Pixel] Initialized:', PIXEL_ID, '— PageView tracked');
  }, []);
  return <noscript data-id="element-112">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-113" />
    </noscript>;
}